export class Image {

  id: number;
  largeUrl: string;
  thumbUrl: string;
  size: string;
  width: number;
  height: number;
  description: string;
  author: string;

  constructor() {}
}
